import styles from './ModalButton.module.scss';
import PulseSpinner from '../../spinner/PulseSpinner';

const ModalModifyButton = ({ label, onClick, isLoading = false }) => {
  return (
    <div className={styles.ButtonContainer}>
      <button
        className={isLoading ? styles.DisabledButton : styles.ModifyButton}
        onClick={onClick}
        disabled={isLoading}>
        {isLoading
          ? <PulseSpinner isLoading={isLoading}/>
          : label
        }
      </button>
    </div>
  )
}

export default ModalModifyButton;